import { Badge, Box, Button, Card, Divider, Flex, FormControl, FormLabel, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, useDisclosure } from '@chakra-ui/react';
import Routes from '../../../common/api_routes';
import CustomTable from 'components/custom-table';
import React, { useEffect, useState } from 'react';
import { ApiKey, OrderStatus, Role } from '../../../common/constant';
import { FaCog } from "react-icons/fa";
import CustomInput from 'components/custom-input';
import { stringIsNullOrEmpty } from 'common/util';
import { Controller, useForm } from 'react-hook-form';
import { formatDecimal } from 'common/util';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { isObjectEmpty } from 'common/util';
import CustomSelect from 'components/custom-select';
import { convertHexStringToBlobData } from 'utils/file';
import ApiEngine from 'common/api-engine';
import { useDispatch, useSelector } from 'react-redux';
import { showCustomDialog } from 'application/action/app_action';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { constructQueryString } from 'common/util';

/**
 * @author Nelson
 */
const OrderHistory = () => {
    const DEFAULT_SUMMARY = {
        totalSales: 0, totalTransactions: 0, totalItems: 0
    }
    const _USER_DATA = useSelector((state) => state.authState.userData);
    console.log(_USER_DATA);
    const _dispatch = useDispatch();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { control: filterControl, handleSubmit: filterSubmit, reset: filterReset, getValues: filterGetValues } = useForm({
        defaultValues: {
            transactionId: '',
            email: '',
            referenceNumber: '',
            status: '',
            dateRange: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });
    const [selectedId, setSelectedId] = useState(null);
    const [filterObj, setFilterObj] = useState({});
    const [items, setItems] = useState([]);
    const [previewImg, setPreviewImg] = useState({});
    const [summary, setSummary] = useState(DEFAULT_SUMMARY);

    const HISTORY_COLUMNS = [
        {
            Header: 'Transaction ID',
            Cell: ({ row }) => {
                return (
                    <Text>{row.original.transactionId}</Text>
                )
            }
        },
        {
            Header: 'Reference Number',
            Cell: ({ row }) => {
                return (
                    <Text>{!stringIsNullOrEmpty(row.original.referenceNumber) ? row.original.referenceNumber : '-'}</Text>
                )
            }
        },
        {
            Header: 'Grand Total (RM)',
            Cell: ({ row }) => {
                return (
                    <Text>{`${formatDecimal(row.original.grandTotal)}`}</Text>
                )
            }
        },
        ...(
            _USER_DATA.roleId != Role._MERCHANT ? [
                {
                    Header: 'Total Items',
                    Cell: ({ row }) => {
                        return (
                            <Text>{row.original.totalQuantity}</Text>
                        )
                    }
                }
            ] : []
        ),
        // {
        //     Header: 'Merchant',
        //     Cell: ({ row }) => {
        //         return (
        //             <Text>{!stringIsNullOrEmpty(row.original.merchantName) ? row.original.merchantName : '-'}</Text>
        //         )
        //     }
        // },
        {
            Header: 'Email',
            Cell: ({ row }) => {
                return (
                    <Text>{row.original.email}</Text>
                )
            }
        },
        {
            Header: 'Status',
            Cell: ({ row }) => {
                return (
                    <Badge colorScheme={row.original.status === OrderStatus._PENDING ? 'yellow' : (row.original.status === OrderStatus._SUCCESS ? 'green' : 'red')}>{row.original.statusName}</Badge>
                )
            }
        },
        {
            Header: 'Order Date',
            Cell: ({ row }) => {
                return (
                    <Text>{row.original.orderDate}</Text>
                )
            }
        },
        {
            Header: 'Payment Date',
            Cell: ({ row }) => {
                return (
                    <Text>{!stringIsNullOrEmpty(row.original.paymentDate) ? row.original.paymentDate : '-'}</Text>
                )
            }
        },
        {
            Header: 'Remark',
            Cell: ({ row }) => {
                return (
                    <Text>{!stringIsNullOrEmpty(row.original.remark) ? row.original.remark : '-'}</Text>
                )
            }
        },
        ...(
            _USER_DATA.roleId != Role._MERCHANT ? [
                {
                    Header: 'Action',
                    Cell: ({ row }) => {
                        return (
                            <Flex display={'flex'} flexDir={'row'} justify={'center'} alignItems={'center'}>
                                <Menu isLazy>
                                    <MenuButton as={IconButton} icon={<FaCog />}>
                                    </MenuButton>
                                    <MenuList>
                                        <MenuItem onClick={() => { setSelectedId(row.original.id); onOpen(); }}>{'View Item(s)'}</MenuItem>
                                    </MenuList>
                                </Menu>
                            </Flex>
                        )
                    }
                }
            ] : []
        )
    ]

    const HISTORY_DETAIL_COLUMNS = [
        {
            Header: 'Image',
            Cell: ({ row }) => {
                const data = URL.createObjectURL(convertHexStringToBlobData(row.original.data));

                return (
                    <Image
                        cursor={'pointer'}
                        onClick={() => setPreviewImg({
                            name: row.original.name,
                            data
                        })}
                        src={data} />
                )
            }
        },
        {
            Header: 'Name',
            Cell: ({ row }) => {
                return (
                    <Text>{row.original.name}</Text>
                )
            }
        },
        {
            Header: 'Price (RM)',
            Cell: ({ row }) => {
                return (
                    <Text>{`${formatDecimal(row.original.price)}`}</Text>
                )
            }
        }
    ]

    /**
     * @author Nelson
     */
    useEffect(() => {
        if (!isOpen) {
            setSelectedId(null);
            setItems([]);
        }
        else if (!stringIsNullOrEmpty(selectedId)) {
            (
                async () => {
                    const response = await ApiEngine.get(`${Routes._ORDER_HISTORY}/${selectedId}`);

                    if (!response[ApiKey._API_SUCCESS_KEY]) {
                        _dispatch(showCustomDialog({
                            success: false,
                            content: response[ApiKey._API_MESSAGE_KEY]
                        }));
                    }
                    else {
                        setItems(response[ApiKey._API_DATA_KEY]);
                    }
                }
            )();
        }
    }, [isOpen, selectedId]);

    /**
     * @author Nelson
     */
    useEffect(() => {
        if (!isObjectEmpty(filterObj)) {
            (
                async () => {
                    const response = await ApiEngine.get(constructQueryString(`${Routes._ORDER_HISTORY_SUMMARY}`, filterObj));

                    if (response[ApiKey._API_SUCCESS_KEY]) {
                        setSummary({
                            ...response[ApiKey._API_DATA_KEY]
                        })
                    }
                }
            )();
        }
        else {
            setSummary(DEFAULT_SUMMARY);
        }
    }, [filterObj])

    /**
     * @author Nelson
     * @param {*} data 
     */
    async function onSubmitFilter(data) {
        let params = { ...data };

        params.startDate = dayjs(params.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        params.endDate = dayjs(params.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');

        delete params.dateRange;

        setFilterObj({ ...params });
    }

    async function exportData() {
        try {
            let params = { ...filterGetValues() };

            params.startDate = dayjs(params.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
            params.endDate = dayjs(params.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
            delete params.dateRange;
            const response = await ApiEngine.get(constructQueryString(`${Routes._ORDER_HISTORY_DOWNLOAD}`, params), {
                responseType: 'blob'
            });

            if (!response || response.size === 0) {
                throw 'Downloaded file is empty or invalid';
            }

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response);
            link.download = `${dayjs(params.startDate).format('YYYY-MM-DD')}_${dayjs(params.endDate).format('YYYY-MM-DD')}`;
            link.click();
            URL.revokeObjectURL(link.href);
        }
        catch (err) {
            _dispatch(showCustomDialog(false, err));
        }
    }

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Card title={'FILTER'} padding={'1rem'}>
                <FormControl inlineSize={'md'} display={'flex'} width={'100%'} flexDir={'row'} flexWrap={'wrap'}>
                    <Controller
                        control={filterControl}
                        name="dateRange"
                        render={({ onChange, value, name }) => (
                            <Stack mb={'20px'} mr={'1rem'}>
                                <FormLabel
                                    display={"flex"}
                                    ms={"4px"}
                                    fontSize={"md"}
                                    fontWeight={"500"}
                                    mb={"3px"}>
                                    {'Date Range'}
                                </FormLabel>
                                <DatePicker.RangePicker
                                    size='large'
                                    showTime
                                    value={value}
                                    onChange={onChange}
                                    name={name}
                                    style={{ paddingInline: '1rem' }} />
                            </Stack>
                        )} />
                    <Controller
                        control={filterControl}
                        name="transactionId"
                        render={({ onChange, value, name }) => (
                            <CustomInput
                                id={name}
                                label={'Transaction ID'}
                                onChange={onChange}
                                style={{ marginRight: '1rem' }}
                                value={value}
                                placeHolder={"Enter transaction ID"} />
                        )} />
                    <Controller
                        control={filterControl}
                        name="referenceNumber"
                        render={({ onChange, value, name }) => (
                            <CustomInput
                                id={name}
                                label={'Reference Number'}
                                style={{ marginRight: '1rem' }}
                                onChange={onChange}
                                value={value}
                                placeHolder={"Enter reference number"} />
                        )} />
                    <Controller
                        control={filterControl}
                        name="email"
                        render={({ onChange, value, name }) => (
                            <CustomInput
                                id={name}
                                style={{ marginRight: '1rem' }}
                                label={'Email'}
                                onChange={onChange}
                                value={value}
                                placeHolder={"Enter email"} />
                        )} />
                    <Controller
                        control={filterControl}
                        name="status"
                        render={({ onChange, value, name }) => (
                            <CustomSelect
                                id={name}
                                onChange={onChange}
                                label={'Status'}
                                value={value}
                                placeholder={'Select a status'}
                                options={[
                                    {
                                        label: 'Pending',
                                        value: OrderStatus._PENDING
                                    },
                                    {
                                        label: 'Success',
                                        value: OrderStatus._SUCCESS
                                    },
                                    {
                                        label: 'Failed',
                                        value: OrderStatus._FAILED
                                    }
                                ]} />
                        )} />
                </FormControl>
                <Divider color={'#e7e7e7'} mb={'1rem'} />
                <Flex direction={'row'}>
                    <Button variant='ghost' onClick={() => { setFilterObj({}); filterReset(); }}>
                        Reset
                    </Button>
                    <Button type='submit' colorScheme='blue' ml={3} onClick={() => filterSubmit(onSubmitFilter)()}>
                        Filter
                    </Button>
                    <Button type='submit' colorScheme='green' ml={3} onClick={() => exportData()}>
                        Export
                    </Button>
                </Flex>
            </Card>
            <Card mt={'1rem'} mb={'1rem'} display={'flex'} flexDir={'row'} justifyContent={'flex-start'} alignItems={'center'} flexWrap={'wrap'}>
                <Flex direction={'column'} marginInline={'2rem'} marginBlock={'1rem'}>
                    <Text fontSize={'2xl'}>{`Total Sales:`}</Text>
                    <Text fontSize={'2xl'}>{`RM${formatDecimal(summary.totalSales)}`}</Text>
                </Flex>
                <Flex direction={'column'} marginInline={'2rem'} marginBlock={'1rem'}>
                    <Text fontSize={'2xl'}>{`Total Transactions:`}</Text>
                    <Text fontSize={'2xl'}>{summary.totalTransactions}</Text>
                </Flex>
                {
                    _USER_DATA.roleId != Role._MERCHANT &&
                    <Flex direction={'column'} marginInline={'2rem'} marginBlock={'1rem'}>
                        <Text fontSize={'2xl'}>{`Total Items:`}</Text>
                        <Text fontSize={'2xl'}>{summary.totalItems}</Text>
                    </Flex>
                }
            </Card>
            {
                !isObjectEmpty(filterObj) &&
                <Card
                    padding={'1rem'}
                    title={'USER_MANAGEMENT'}
                    justifyContent='center'
                    direction='column'
                    w='100%'
                    mb='0px'>
                    <CustomTable objFilter={filterObj} columnsData={HISTORY_COLUMNS} apiUrl={`${Routes._ORDER_HISTORY}`} />
                </Card>
            }
            {
                isObjectEmpty(filterObj) &&
                <Card
                    padding={'1rem'}
                    title={'USER_MANAGEMENT'}
                    justifyContent='center'
                    direction='column'
                    w='100%'
                    mb='0px'>
                    <CustomTable objFilter={filterObj} columnsData={HISTORY_COLUMNS} apiUrl={``} />
                </Card>
            }
            <Modal isOpen={isOpen} onClose={onClose} scrollBehavior='inside'>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{'Order Item(s)'}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <CustomTable objFilter={filterObj} dataSize={items.length} columnsData={HISTORY_DETAIL_COLUMNS} tableData={items} />
                    </ModalBody>
                    <ModalFooter>
                        <Button variant='ghost' onClick={onClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Lightbox
                index={items.findIndex(e => e.name === previewImg?.name)}
                plugins={[Zoom]}
                zoom={{ scrollToZoom: true, maxZoomPixelRatio: 3 }}
                inline={{ style: { aspectRatio: "1 / 1", width: '100%' } }}
                open={!isObjectEmpty(previewImg)}
                close={() => setPreviewImg({})}
                slides={[
                    {
                        src: previewImg?.data,
                        width: 1024,
                        height: 1024,
                        srcSet: []
                    }
                ]} />
        </Box>
    )
}

export default OrderHistory;